import { isNonOwaError, isOneOf } from 'owa-config';

const knownExternalStrings: string[] = [
    'https://swc.cdn.skype.com',
    'https://acdn.adnxs.com/',
    'https://s.aolcdn.com',
    '/resources/suiteux-shell/',
    '{"isCanceled":true}',
    'lpcres.delve.office.com/',
];

export function isExternalError(message: string, stack: string): boolean {
    return (
        isNonOwaError(stack) ||
        isOneOf(knownExternalStrings, message) ||
        isOneOf(knownExternalStrings, stack)
    );
}
